import { store } from 'store/index'
import { useEffect, useMemo } from 'react'
import { appVersionActions, appVersionSelectors } from 'store/app-version'
import { useAppVersion } from 'hooks/useAppVersion'
import { AppVersion } from 'types/app-version'
import { BUILD_TYPE } from '../../config'
import { useTranslation } from 'react-i18next'
import { socketSingleton } from 'services/ws'

export const AppVersionBanner = () => {
  const { reloadWindowAndClearServiceWorker, getLastPipelineVersion } = useAppVersion()
  const state = store.getState()
  const isUpdateAvailable = appVersionSelectors.isUpdateAvailable(state)
  const lastPipelineVersion = appVersionSelectors.lastPipelineVersion(state)
  const { t } = useTranslation()

  const newUpdateAvailable = useMemo(() => {
    return isUpdateAvailable
  }, [isUpdateAvailable])

  const initializeWebSocket = () => {
    socketSingleton.connectTo<AppVersion>('app-versions', (appVersion) => {
      if (appVersion.name === BUILD_TYPE) {
        store.dispatch(appVersionActions.setLastPipelineVersion(appVersion.version))
      }
    })
  }

  const handleVisibilityChange = async () => {
    if (!document.hidden) {
      console.log('User returned to the page')
      await getLastPipelineVersion(false)
      initializeWebSocket()
    }
  }

  const setupVisibilityListener = () => {
    document.addEventListener('visibilitychange', handleVisibilityChange)
  }

  useEffect(() => {
    const initialize = async () => {
      await getLastPipelineVersion(true)
      setupVisibilityListener()
      setTimeout(() => {
        initializeWebSocket()
      }, 500)
    }

    initialize()

    return () => {
      socketSingleton.disconnectTo('app-versions')
      document.removeEventListener('visibilitychange', handleVisibilityChange)
    }
  }, [])

  return (
    <>
      {newUpdateAvailable && (
        <div
          className="tw-text-xs tw-underline tw-cursor-pointer tw-mt-0.5"
          onClick={reloadWindowAndClearServiceWorker}
        >
          {t('versions.availableTitle')} ({lastPipelineVersion}) 🚀
        </div>
      )}
    </>
  )
}
